export default __webpack_public_path__ + "static/media/PDF.930e29b8.svg";